import { EstadoComponente } from "@/shared/components/ui";
import { OrdenesCompra } from "@/shared/interfaces/erp/compras/ordenes-compra.interface"
import { MRT_ColumnDef, MRT_RowData } from "material-react-table"
import { useMemo, useState } from "react"
import VisibilityIcon from '@mui/icons-material/Visibility';
import { cellNotFilter, formatDateWithTimeCell, TABLE_CONSTANTS_COLUMS } from "@/shared";
import { MaterialTransferido } from "@/shared/interfaces";
import { useCargarSeriesProductos } from "@/store/erp/productos/useCargarSeriesProductos.store";
import { Box, Button, Chip, Typography } from "@mui/material";
import DoneIcon from '@mui/icons-material/Done';
import ModalObservacionGeneral from "@/shared/components/ui/ModalObservacionesGeneral";


export default function useTableOrdeneCompra() {
  //store
  const handldeCopiarLista = useCargarSeriesProductos(s => s.handleCopiarLista)
  const [isOpenModal, setIsOpenModal] = useState(false)

  const onDetails = (e: MRT_RowData) => {
    console.log('data', e)
    handldeCopiarLista(e.detalles)
    setIsOpenModal(true)

  }
  const infoOrdenCompra = useMemo<MRT_ColumnDef<OrdenesCompra>[]>(
    () => [
      {
        accessorKey: 'detalles',
        header: 'Producto',
        enableColumnFilter: false,
        enableSorting: false,
        size: 30,
        Cell: ({ row }) => {
          return (
            <Button
              variant="text"
              color="primary"
              startIcon={<VisibilityIcon />}
              onClick={() => onDetails(row.original)}
            >
              {'Ver'}
            </Button>
          );
        }
      },
      {
        accessorKey: 'numero_referencia',
        header: 'numero referencia',
      },
      {
        ...cellNotFilter,
        accessorKey: 'observaciones.observacionRevisor',
        header: 'observación del Revisor',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_LARGE,
        Cell: ({ row }) => (
          <ModalObservacionGeneral
            texto={row.original.observaciones?.observacionRevisor || 'N/A'}
            title="Observación"
          />
        )

      },
      {
        accessorKey: 'plazo_pago',
        header: 'plazo pago',

      },
      {
        ...cellNotFilter,
        accessorKey: 'fecha_orden',
        header: 'fecha orden',
        Cell: ({ row }) => formatDateWithTimeCell(row, 'fecha_orden')

      },
      {
        ...cellNotFilter,
        accessorKey: 'fecha_compra',
        header: 'fecha Compra',
        Cell: ({ row }) => formatDateWithTimeCell(row, 'fecha_compra')

      },
      {
        ...cellNotFilter,
        accessorKey: 'fecha_entrega',
        header: 'fecha entrega',
        Cell: ({ row }) => formatDateWithTimeCell(row, 'fecha_entrega')
      },
      {
        accessorKey: 'forma_pago_data.nombre',
        header: 'forma_pago',
        Cell: ({ row }) => row.original?.forma_pago_data?.nombre || 'N/A'
      },
      {
        accessorKey: 'solicitud_ingreso',
        header: 'solicitud ingreso',

        Cell: ({ row }) => row.original?.solicitud_ingreso || 'N/A'
      },
      {
        accessorKey: 'proveedor_data.razon_social',
        header: 'proveedor',

      },
      {
        accessorKey: "estado_solicitud",
        header: "estado",

        /* enableColumnFilter:false,
        enableSorting:false, */
        Cell: ({ row }) =>
          row.original.estado_orden != null ? (
            <EstadoComponente
              backgroundColor="blue"
              texto={row.original.estado_orden || ""}
            />
          ) : null,
      }

    ], [])

  const infoProducto = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(
    () => [
      {
        accessorKey: 'codigo',
        header: 'Código',
        Cell: ({ row }) => row.original?.codigo || 'N/A',
      },
      {
        accessorKey: 'descripcion',
        header: 'Descripción',
        Cell: ({ row }) => row.original?.producto_data?.descripcion || 'N/A',
      },
      {
        accessorKey: 'producto_data.unidad_medida',
        header: 'Unidad Medida',
        Cell: ({ row }) => row.original?.producto_data?.unidad_medida || 'N/A'
      },
      {
        accessorKey: 'producto_data.modelo_producto',
        header: 'Modelo',
        Cell: ({ row }) => row.original?.producto_data?.modelo_producto || 'N/A'
      },
      {
        accessorKey: 'producto_data.marca_producto',
        header: 'Marca',
        Cell: ({ row }) => row.original?.producto_data?.marca_producto || 'N/A'
      },
      {
        accessorKey: 'producto_data.categoria_producto',
        header: 'Categoria',
      },
      {
        accessorKey: 'cantidad_aprobada',
        header: 'Cant. Aprobada'
      },
      {
        accessorKey: 'cantidad',
        header: 'Cant. Requerida'
      },
      {
        accessorKey: 'cantidad_recibida',
        header: 'Cant. Recibida',


      }
    ], []
  )
  const detallesProductos = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(
    () => [
      {
        accessorKey: 'cantidad_pendiente',
        header: 'cant. Pendiente',
        Cell: ({ row }) => {
          return (
            <Typography color={"warning.main"}>
              {row.original?.cantidad_pendiente}
            </Typography>
          )
        }
      },
      {
        accessorKey: 'producto_data.descripcion',
        header: 'descripción'
      },
      {
        accessorKey: 'codigo',
        header: 'Código',
        Cell: ({ row }) => row.original?.codigo || 'N/A',
      },
      {
        accessorKey: 'cantidad_aprobada',
        header: 'Cant. Aprobada'
      },
      {
        accessorKey: 'cantidad',
        header: 'cant. Esperada',
      },
      {
        accessorKey: 'cantidad_recibida',
        header: 'Cant. Recibida',
        Cell: ({ row }) => {
          const { cantidad, cantidad_recibida } = row.original
          const cantidadTotal = Number(cantidad) === cantidad_recibida
          return (
            <>
              <Chip
                label={
                  <Box display="flex" alignItems="center" gap={0.5}>
                    {cantidad_recibida}
                    {cantidadTotal && <DoneIcon fontSize="small" />}
                  </Box>
                }
                variant="filled"
                style={{ backgroundColor: cantidadTotal ? '#4caf50' : '#ED6C02', padding: '0 10px', borderRadius: '4 px', color: '#fff' }}

              />
            </>
          )
        }
      }


    ], []
  )
  ///parcial
  const infoDetallesAbierto = useMemo<MRT_ColumnDef<OrdenesCompra>[]>(
    () => [
      {
        accessorKey: 'numero_referencia',
        header: 'numero referencia',
      },
      {
        ...cellNotFilter,
        accessorKey: 'observaciones.observacionRevisor',
        header: 'observación del Revisor',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_LARGE,
        Cell: ({ row }) => (
          <ModalObservacionGeneral
            texto={row.original.observaciones?.observacionRevisor || 'N/A'}
            title="Observación"
          />
        )

      },
      {
        accessorKey: 'plazo_pago',
        header: 'plazo pago',

      },
      {
        ...cellNotFilter,
        accessorKey: 'fecha_orden',
        header: 'fecha orden',
        Cell: ({ row }) => formatDateWithTimeCell(row, 'fecha_orden')

      },
      {
        ...cellNotFilter,
        accessorKey: 'fecha_compra',
        header: 'fecha Compra',
        Cell: ({ row }) => formatDateWithTimeCell(row, 'fecha_compra')

      },
      {
        ...cellNotFilter,
        accessorKey: 'fecha_entrega',
        header: 'fecha entrega',
        Cell: ({ row }) => formatDateWithTimeCell(row, 'fecha_entrega')
      },
      {
        accessorKey: 'forma_pago_data.nombre',
        header: 'forma_pago',
        Cell: ({ row }) => row.original?.forma_pago_data?.nombre || 'N/A'
      },
      {
        accessorKey: 'solicitud_ingreso',
        header: 'solicitud ingreso',

        Cell: ({ row }) => row.original?.solicitud_ingreso || 'N/A'
      },
      {
        accessorKey: 'proveedor_data.razon_social',
        header: 'proveedor',

      },
      {
        accessorKey: "estado_solicitud",
        header: "estado",

        /* enableColumnFilter:false,
        enableSorting:false, */
        Cell: ({ row }) =>
          row.original.estado_orden != null ? (
            <EstadoComponente
              backgroundColor="blue"
              texto={row.original.estado_orden || ""}
            />
          ) : null,
      }

    ], []
  )
  return {
    infoOrdenCompra,
    infoProducto,
    isOpenModal,
    setIsOpenModal,
    detallesProductos,
    infoDetallesAbierto
  }
}